export const Points = ({ className }: any) => {
	return (
		<svg
			width="44"
			height="44"
			viewBox="0 0 44 44"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<rect width="44" height="44" rx="22" fill="white" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.1469 9.77618L26.207 16.7814C26.2379 16.8563 26.2875 16.9211 26.3506 16.9689C26.4137 17.0168 26.4879 17.046 26.5655 17.0534L33.8789 17.9338C34.1197 17.9615 34.3477 18.0613 34.5357 18.2212C34.7236 18.3812 34.8634 18.5945 34.9383 18.8356C35.0132 19.0766 35.0201 19.3352 34.958 19.5802C34.8959 19.8252 34.7675 20.0462 34.5883 20.2168L29.1664 25.4259C29.1075 25.4797 29.0635 25.5491 29.0393 25.6269C29.015 25.7047 29.0113 25.7879 29.0286 25.8677L30.4882 33.417C30.5377 33.665 30.5177 33.9227 30.4305 34.159C30.3432 34.3954 30.1926 34.6003 29.9967 34.7492C29.8007 34.898 29.5678 34.9845 29.326 34.9981C29.0842 35.0117 28.8438 34.9519 28.6338 34.8259L22.2225 31.0406C22.155 30.9996 22.0784 30.978 22.0004 30.978C21.9224 30.978 21.8457 30.9996 21.7782 31.0406L15.3656 34.8259C15.1555 34.9516 14.9152 35.0111 14.6735 34.9973C14.4319 34.9835 14.1992 34.897 14.0034 34.7482C13.8076 34.5994 13.657 34.3947 13.5697 34.1585C13.4824 33.9224 13.4622 33.6649 13.5114 33.417L14.971 25.8677C14.9883 25.7879 14.9846 25.7047 14.9603 25.6269C14.9361 25.5491 14.8921 25.4797 14.8332 25.4259L9.41245 20.2162C9.23299 20.0457 9.10441 19.8247 9.04218 19.5796C8.97994 19.3345 8.9867 19.0758 9.06164 18.8347C9.13658 18.5935 9.27651 18.3801 9.4646 18.2202C9.65269 18.0603 9.88094 17.9606 10.1219 17.9332L17.4364 17.0528C17.514 17.0454 17.5883 17.0162 17.6514 16.9683C17.7144 16.9205 17.764 16.8557 17.7949 16.7808L20.8539 9.77618C20.9532 9.54495 21.1142 9.34867 21.3176 9.21097C21.521 9.07326 21.7581 9 22.0004 9C22.2427 9 22.4798 9.07326 22.6832 9.21097C22.8866 9.34867 23.0476 9.54495 23.1469 9.77618Z"
				fill="#FFAE00"
			/>
			<rect
				x="2.5"
				y="2.5"
				width="39"
				height="39"
				rx="19.5"
				stroke="#FFAE00"
			/>
		</svg>
	);
};
